import React from 'react';
import styled from 'styled-components';

const ErrorContainer = styled.div`
  background-color: #fff8f8;
  border: 1px solid ${props => props.theme.colors.error};
  border-radius: ${props => props.theme.borderRadius};
  padding: 20px;
  margin: 20px 0;
  text-align: center;
`;

const ErrorIcon = styled.div`
  color: ${props => props.theme.colors.error};
  font-size: 24px;
  margin-bottom: 10px;
`;

const ErrorMessage = styled.p`
  color: ${props => props.theme.colors.text};
  margin-bottom: 15px;
`;

const RetryButton = styled.button`
  background-color: ${props => props.theme.colors.primary};
  &:hover {
    background-color: #0062c1;
  }
`;

function Error({ message, onRetry }) {
  return (
    <ErrorContainer>
      <ErrorIcon>⚠️</ErrorIcon>
      <ErrorMessage>{message || 'Something went wrong. Please try again.'}</ErrorMessage>
      {onRetry && (
        <RetryButton onClick={onRetry}>
          Try Again
        </RetryButton>
      )}
    </ErrorContainer>
  );
}

export default Error; 